import { render } from "./ReservationOverview.vue?vue&type=template&id=413a2ddf&scoped=true"
import script from "./ReservationOverview.vue?vue&type=script&lang=js"
export * from "./ReservationOverview.vue?vue&type=script&lang=js"

import "./ReservationOverview.vue?vue&type=style&index=0&id=413a2ddf&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413a2ddf"]])

export default __exports__